import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';

export default function PaymentStatus() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<'success' | 'failure' | null>(null);

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/success')) {
      setStatus('success');
    } else if (path.includes('/cancel') || path.includes('/failure')) {
      setStatus('failure');
    }
  }, []);

  if (!status) return null;

  return (
    <div className="container flex min-h-screen flex-col items-center justify-center p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-lg">
        {status === 'success' ? (
          <>
            <div className="flex flex-col items-center">
              <i className="bi bi-check-circle h-30 w-30 mb-4 rounded-full p-4 text-[3rem] text-black"></i>
              <h2 className="mb-2 text-2xl font-bold text-gray-900">Payment Successful!</h2>
              <p className="mb-6 text-center text-gray-600">
                Thank you for your payment. Your transaction has been completed successfully.
              </p>
            </div>
            <div className="space-y-3">
              <button
                onClick={() => navigate('/')}
                className="w-full rounded-md bg-gray-200 px-4 py-3 text-gray-800 transition-colors duration-200 hover:bg-gray-300"
              >
                Return to Dashboard
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col items-center">
              <i className="bi bi-x-circle h-30 w-30 mb-4 rounded-full p-4 text-[3rem] text-black"></i>
              <h2 className="mb-2 text-2xl font-bold text-gray-900">Payment Failed</h2>
              <p className="mb-6 text-center text-gray-600">
                We&apos;re sorry, but your payment could not be processed. Please try again or contact support if the
                problem persists.
              </p>
            </div>
            <div className="space-y-3">
              <button
                onClick={() => navigate(-1)}
                className="bg-red-500 hover:bg-red-600 w-full rounded-md px-4 py-3 text-white transition-colors duration-200"
              >
                Try Again
              </button>
              <button
                onClick={() => navigate('/')}
                className="w-full rounded-md bg-gray-200 px-4 py-3 text-gray-800 transition-colors duration-200 hover:bg-gray-300"
              >
                Return to Dashboard
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
